import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ApplicationConfig, importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, ROUTES, withComponentInputBinding } from '@angular/router';
import { NptConfiguration, NptCoreModule, NptI18nConfiguration, nptMenuServiceToken } from '@npt/sdk';

import packageJson from '../../package.json';
import { environment } from '../environments/environment';
import { MenuItems } from '../sidebar-menu/menu-items';
import { AppRoutesService } from './app.routes';

export const i18nConfig: NptI18nConfiguration = {
  defaultLocale: 'it-IT',
  locales: ['it-IT', 'de-DE'],
  bundles: [
    { prefix: './assets/i18n/npt/core/', suffix: '.json' },
    { prefix: './assets/i18n/npt/table/', suffix: '.json' },
    { prefix: './assets/i18n/npt/overlay/', suffix: '.json' },
    { prefix: './assets/i18n/npt/date-time-range/', suffix: '.json' },
    { prefix: './assets/i18n/npt/page-render/', suffix: '.json' },
    { prefix: './assets/i18n/', suffix: '.json' }
  ],
};

export const nptConf: NptConfiguration = {
  i18n: i18nConfig,
  securityType: 'oauth2',
  configFile: environment.configFile,
  landingPageURL: ['/register', '/register-complete', '/cashback-request', '/pages/terms-condition.html'],
  version: packageJson.version
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter([], withComponentInputBinding()),
    {
      provide: ROUTES,
      multi: true,
      useFactory: () => inject(AppRoutesService).buildRoutes()
    },
    importProvidersFrom(NptCoreModule.forRoot(nptConf)),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: nptMenuServiceToken, useClass: MenuItems },
  ]
};
